module.exports = __webpack_public_path__ + "img/default-fixed-top-nav-cjdr.3719fc18.png";